// Tipos de dominio que existen en el backend (cada uno es una tabla de opciones)
export type DomainType =
  | 'PRODUCT_TIME'
  | 'PROJECT_TIME'
  | 'GENERAL_ACTIVITY'
  | 'ACTIVITY_OBJECTIVE_ATENTION'
  | 'ACTIVITY_OBJECTIVE_COMMUNICATION'
  | 'ACTIVITY_OBJECTIVE_DATA_DEV'
  | 'ACTIVITY_OBJECTIVE_STRCUTURE_PROCESS'
  | 'ACTIVITY_OBJECTIVE_MNG_PROCESSES'
  | 'ACTIVITY_OBJECTIVE_PLAN_STRATEGY'
  | 'ACTIVITY_OBJECTIVE_REPORTING'
  | 'ACTIVITY_OBJECTIVE_HUMAN_TALENT_ABSENTEEISM'
  | 'SPECIFIC_ACTIVITY_ATTENTION_SOLI'
  | 'SPECIFIC_ACTIVITY_ATTENTION_TABLE'
  | 'SPECIFIC_ACTIVITY_DESIGN'
  | 'SPECIFIC_ACTIVITY_SUPPORT'
  | 'SPECIFIC_ACTIVITY_DEV'
  | 'SPECIFIC_ACTIVITY_CAPACITY'
  | 'SPECIFIC_ACTIVITY_MODEL_BI'
  | 'SPECIFIC_ACTIVITY_TABLE_BI'
  | 'SPECIFIC_ACTIVITY_STANDARD'
  | 'SPECIFIC_ACTIVITY_INSTRUCTIVE'
  | 'SPECIFIC_ACTIVITY_OPERATION'
  | 'SPECIFIC_ACTIVITY_ADMINTH'
  | 'SPECIFIC_ACTIVITY_CAP_DEV'
  | 'SPECIFIC_ACTIVITY_CONT_FIN'
  | 'SPECIFIC_ACTIVITY_MNG_ADMIN'
  | 'SPECIFIC_ACTIVITY_DEV_BUSINESS_INNOVATION'
  | 'SPECIFIC_ACTIVITY_CULTURE_WELLBEING'
  | 'SPECIFIC_ACTIVITY_CAMPAIGN_CALLING'
  | 'SPECIFIC_ACTIVITY_MNG_CONTRACT'
  | 'SPECIFIC_ACTIVITY_MNG_DISENGAGEMENT'
  | 'SPECIFIC_ACTIVITY_MNG_ECOEFICIENCIA'
  | 'SPECIFIC_ACTIVITY_MNG_PAYMENTS'
  | 'SPECIFIC_ACTIVITY_MNG_REPORTING'
  | 'SPECIFIC_ACTIVITY_MNG_SEL_ENG_CONTRT'
  | 'SPECIFIC_ACTIVITY_MNG_SUSTAINABILITY'
  | 'SPECIFIC_ACTIVITY_PERFORMANCE'
  | 'SPECIFIC_ACTIVITY_MNG_DOCUMENT_TH'
  | 'SPECIFIC_ACTIVITY_MNG_FUTURE_V'
  | 'SPECIFIC_ACTIVITY_MNG_INDUCTION_REDUCTION'
  | 'SPECIFIC_ACTIVITY_MNG_MARKET_TARIFFS'
  | 'SPECIFIC_ACTIVITY_MNG_PLANNING'
  | 'SPECIFIC_ACTIVITY_MNG_SOLUTION_TECH'
  | 'SPECIFIC_ACTIVITY_INTERNAL'
  | 'SPECIFIC_ACTIVITY_SG_SST'
  | 'SPECIFIC_ACTIVITY_SYSTEM_MNG_INTEGRAL'
  | 'SPECIFIC_ACTIVITY_VERTEBRA_HELP_INTERNAL'
  | 'SPECIFIC_ACTIVITY_ALIGN_STRATEGY'
  | 'SPECIFIC_ACTIVITY_COORDINATION_AREAS'
  | 'SPECIFIC_ACTIVITY_DIRECTION_TEAM'
  | 'SPECIFIC_ACTIVITY_STRATEGY_COMPANY'
  | 'SPECIFIC_ACTIVITY_REPORTS_ECOEFICIENCIA'
  | 'SPECIFIC_ACTIVITY_REPORTS_INTERNAL'
  | 'SPECIFIC_ACTIVITY_REPORTS_MARKET_TARRIFS'
  | 'SPECIFIC_ACTIVITY_REPORTS_PAYMENTS'
  | 'SPECIFIC_ACTIVITY_REPORTS_SOLUTIONS_TECH'
  | 'SPECIFIC_ACTIVITY_ABSENT_WORK'
  | 'SPECIFIC_ACTIVITY_CULTURAL_VERTEBRA'
  | 'SPECIFIC_ACTIVITY_DISENGAGEMENT'
  | 'SPECIFIC_ACTIVITY_INDUCTION_REINDUCTION'
  | 'SPECIFIC_ACTIVITY_SELECTION'
  | 'SPECIFIC_ACTIVITY_SYSTEM_MNG'
  | 'ACTIVITY_TYPE_TASK'
  | 'MEDIUM_REQUEST_TASK'
  | 'STATUS_TASK'

// Mapea un tipo de dominio a su alias en la query GQL y su key en el state/listas
export interface DomainConfigItem {
  type: DomainType
  stateKey: string
  listKey: string
  alias: string
}

/* Configuracion de todos los dominios: producto, proyecto, actividad general,
   objetivos por actividad (8 tipos), y actividades especificas (~40 tipos).
   Cada item genera un alias en GET_DOMAINS y una lista en domainDataList. */
export const DOMAIN_CONFIG: DomainConfigItem[] = [
  {
    type: 'PRODUCT_TIME',
    stateKey: 'product',
    listKey: 'productList',
    alias: 'PRODUCT_TIME'
  },
  {
    type: 'PROJECT_TIME',
    stateKey: 'project',
    listKey: 'projectList',
    alias: 'PROJECT_TIME'
  },
  {
    type: 'GENERAL_ACTIVITY',
    stateKey: 'generalActivity',
    listKey: 'generalActivityList',
    alias: 'GENERAL_ACTIVITY'
  },
// ── Objetivos por actividad general (8 tipos) ──
  {
    type: 'ACTIVITY_OBJECTIVE_ATENTION',
    stateKey: 'activityObjectiveAtention',
    listKey: 'activityObjectiveAtentionList',
    alias: 'ACTIVITY_OBJECTIVE_ATENTION'
  },
  {
    type: 'ACTIVITY_OBJECTIVE_COMMUNICATION',
    stateKey: 'activityObjectiveCommunication',
    listKey: 'activityObjectiveCommunicationList',
    alias: 'ACTIVITY_OBJECTIVE_COMMUNICATION'
  },
  {
    type: 'ACTIVITY_OBJECTIVE_DATA_DEV',
    stateKey: 'activityObjectiveDataDev',
    listKey: 'activityObjectiveDataDevList',
    alias: 'ACTIVITY_OBJECTIVE_DATA_DEV'
  },
  {
    type: 'ACTIVITY_OBJECTIVE_STRCUTURE_PROCESS',
    stateKey: 'activityObjectiveStructureProcess',
    listKey: 'activityObjectiveStructureProcessList',
    alias: 'ACTIVITY_OBJECTIVE_STRCUTURE_PROCESS'
  },
  {
    type: 'ACTIVITY_OBJECTIVE_MNG_PROCESSES',
    stateKey: 'activityObjectiveMngProcesses',
    listKey: 'activityObjectiveMngProcessesList',
    alias: 'ACTIVITY_OBJECTIVE_MNG_PROCESSES'
  },
  {
    type: 'ACTIVITY_OBJECTIVE_PLAN_STRATEGY',
    stateKey: 'activityObjectivePlanStrategy',
    listKey: 'activityObjectivePlanStrategyList',
    alias: 'ACTIVITY_OBJECTIVE_PLAN_STRATEGY'
  },
  {
    type: 'ACTIVITY_OBJECTIVE_REPORTING',
    stateKey: 'activityObjectiveReporting',
    listKey: 'activityObjectiveReportingList',
    alias: 'ACTIVITY_OBJECTIVE_REPORTING'
  },
  {
    type: 'ACTIVITY_OBJECTIVE_HUMAN_TALENT_ABSENTEEISM',
    stateKey: 'activityObjectiveHumanTalentAbsenteeism',
    listKey: 'activityObjectiveHumanTalentAbsenteeismList',
    alias: 'ACTIVITY_OBJECTIVE_HUMAN_TALENT_ABSENTEEISM'
  },
 // ── Actividades especificas por objetivo (~40 tipos) ──
  {
    type: 'SPECIFIC_ACTIVITY_ATTENTION_SOLI',
    stateKey: 'specificActivityAttentionSoli',
    listKey: 'specificActivityAttentionSoliList',
    alias: 'SPECIFIC_ACTIVITY_ATTENTION_SOLI'
  },
  {
    type: 'SPECIFIC_ACTIVITY_ATTENTION_TABLE',
    stateKey: 'specificActivityAttentionTable',
    listKey: 'specificActivityAttentionTableList',
    alias: 'SPECIFIC_ACTIVITY_ATTENTION_TABLE'
  },
  {
    type: 'SPECIFIC_ACTIVITY_DESIGN',
    stateKey: 'specificActivityDesign',
    listKey: 'specificActivityDesignList',
    alias: 'SPECIFIC_ACTIVITY_DESIGN'
  },
  {
    type: 'SPECIFIC_ACTIVITY_SUPPORT',
    stateKey: 'specificActivitySupport',
    listKey: 'specificActivitySupportList',
    alias: 'SPECIFIC_ACTIVITY_SUPPORT'
  },
  {
    type: 'SPECIFIC_ACTIVITY_DEV',
    stateKey: 'specificActivityDev',
    listKey: 'specificActivityDevList',
    alias: 'SPECIFIC_ACTIVITY_DEV'
  },
  {
    type: 'SPECIFIC_ACTIVITY_CAPACITY',
    stateKey: 'specificActivityCapacity',
    listKey: 'specificActivityCapacityList',
    alias: 'SPECIFIC_ACTIVITY_CAPACITY'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MODEL_BI',
    stateKey: 'specificActivityModelBi',
    listKey: 'specificActivityModelBiList',
    alias: 'SPECIFIC_ACTIVITY_MODEL_BI'
  },
  {
    type: 'SPECIFIC_ACTIVITY_TABLE_BI',
    stateKey: 'specificActivityTableBi',
    listKey: 'specificActivityTableBiList',
    alias: 'SPECIFIC_ACTIVITY_TABLE_BI'
  },
  {
    type: 'SPECIFIC_ACTIVITY_STANDARD',
    stateKey: 'specificActivityStandard',
    listKey: 'specificActivityStandardList',
    alias: 'SPECIFIC_ACTIVITY_STANDARD'
  },
  {
    type: 'SPECIFIC_ACTIVITY_INSTRUCTIVE',
    stateKey: 'specificActivityInstructive',
    listKey: 'specificActivityInstructiveList',
    alias: 'SPECIFIC_ACTIVITY_INSTRUCTIVE'
  },
  {
    type: 'SPECIFIC_ACTIVITY_OPERATION',
    stateKey: 'specificActivityOperation',
    listKey: 'specificActivityOperationList',
    alias: 'SPECIFIC_ACTIVITY_OPERATION'
  },
  {
    type: 'SPECIFIC_ACTIVITY_ADMINTH',
    stateKey: 'specificActivityAdminth',
    listKey: 'specificActivityAdminthList',
    alias: 'SPECIFIC_ACTIVITY_ADMINTH'
  },
  {
    type: 'SPECIFIC_ACTIVITY_CAP_DEV',
    stateKey: 'specificActivityCapDev',
    listKey: 'specificActivityCapDevList',
    alias: 'SPECIFIC_ACTIVITY_CAP_DEV'
  },
  {
    type: 'SPECIFIC_ACTIVITY_CONT_FIN',
    stateKey: 'specificActivityContFin',
    listKey: 'specificActivityContFinList',
    alias: 'SPECIFIC_ACTIVITY_CONT_FIN'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_ADMIN',
    stateKey: 'specificActivityMngAdmin',
    listKey: 'specificActivityMngAdminList',
    alias: 'SPECIFIC_ACTIVITY_MNG_ADMIN'
  },
  {
    type: 'SPECIFIC_ACTIVITY_DEV_BUSINESS_INNOVATION',
    stateKey: 'specificActivityDevBusinessInnovation',
    listKey: 'specificActivityDevBusinessInnovationList',
    alias: 'SPECIFIC_ACTIVITY_DEV_BUSINESS_INNOVATION'
  },
  {
    type: 'SPECIFIC_ACTIVITY_CULTURE_WELLBEING',
    stateKey: 'specificActivityCultureWellbeing',
    listKey: 'specificActivityCultureWellbeingList',
    alias: 'SPECIFIC_ACTIVITY_CULTURE_WELLBEING'
  },
  {
    type: 'SPECIFIC_ACTIVITY_CAMPAIGN_CALLING',
    stateKey: 'specificActivityCampaignCalling',
    listKey: 'specificActivityCampaignCallingList',
    alias: 'SPECIFIC_ACTIVITY_CAMPAIGN_CALLING'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_CONTRACT',
    stateKey: 'specificActivityMngContract',
    listKey: 'specificActivityMngContractList',
    alias: 'SPECIFIC_ACTIVITY_MNG_CONTRACT'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_DISENGAGEMENT',
    stateKey: 'specificActivityMngDisengagement',
    listKey: 'specificActivityMngDisengagementList',
    alias: 'SPECIFIC_ACTIVITY_MNG_DISENGAGEMENT'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_ECOEFICIENCIA',
    stateKey: 'specificActivityMngEcoeficiencia',
    listKey: 'specificActivityMngEcoeficienciaList',
    alias: 'SPECIFIC_ACTIVITY_MNG_ECOEFICIENCIA'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_PAYMENTS',
    stateKey: 'specificActivityMngPayments',
    listKey: 'specificActivityMngPaymentsList',
    alias: 'SPECIFIC_ACTIVITY_MNG_PAYMENTS'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_REPORTING',
    stateKey: 'specificActivityMngReporting',
    listKey: 'specificActivityMngReportingList',
    alias: 'SPECIFIC_ACTIVITY_MNG_REPORTING'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_SEL_ENG_CONTRT',
    stateKey: 'specificActivityMngSelEngContrt',
    listKey: 'specificActivityMngSelEngContrtList',
    alias: 'SPECIFIC_ACTIVITY_MNG_SEL_ENG_CONTRT'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_SUSTAINABILITY',
    stateKey: 'specificActivityMngSustainability',
    listKey: 'specificActivityMngSustainabilityList',
    alias: 'SPECIFIC_ACTIVITY_MNG_SUSTAINABILITY'
  },
  {
    type: 'SPECIFIC_ACTIVITY_PERFORMANCE',
    stateKey: 'specificActivityPerformance',
    listKey: 'specificActivityPerformanceList',
    alias: 'SPECIFIC_ACTIVITY_PERFORMANCE'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_DOCUMENT_TH',
    stateKey: 'specificActivityMngDocumentTh',
    listKey: 'specificActivityMngDocumentThList',
    alias: 'SPECIFIC_ACTIVITY_MNG_DOCUMENT_TH'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_FUTURE_V',
    stateKey: 'specificActivityMngFutureV',
    listKey: 'specificActivityMngFutureVList',
    alias: 'SPECIFIC_ACTIVITY_MNG_FUTURE_V'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_INDUCTION_REDUCTION',
    stateKey: 'specificActivityMngInductionReduction',
    listKey: 'specificActivityMngInductionReductionList',
    alias: 'SPECIFIC_ACTIVITY_MNG_INDUCTION_REDUCTION'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_MARKET_TARIFFS',
    stateKey: 'specificActivityMngMarketTariffs',
    listKey: 'specificActivityMngMarketTariffsList',
    alias: 'SPECIFIC_ACTIVITY_MNG_MARKET_TARIFFS'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_PLANNING',
    stateKey: 'specificActivityMngPlanning',
    listKey: 'specificActivityMngPlanningList',
    alias: 'SPECIFIC_ACTIVITY_MNG_PLANNING'
  },
  {
    type: 'SPECIFIC_ACTIVITY_MNG_SOLUTION_TECH',
    stateKey: 'specificActivityMngSolutionTech',
    listKey: 'specificActivityMngSolutionTechList',
    alias: 'SPECIFIC_ACTIVITY_MNG_SOLUTION_TECH'
  },
  {
    type: 'SPECIFIC_ACTIVITY_INTERNAL',
    stateKey: 'specificActivityInternal',
    listKey: 'specificActivityInternalList',
    alias: 'SPECIFIC_ACTIVITY_INTERNAL'
  },
  {
    type: 'SPECIFIC_ACTIVITY_SG_SST',
    stateKey: 'specificActivitySgSst',
    listKey: 'specificActivitySgSstList',
    alias: 'SPECIFIC_ACTIVITY_SG_SST'
  },
  {
    type: 'SPECIFIC_ACTIVITY_SYSTEM_MNG_INTEGRAL',
    stateKey: 'specificActivitySystemMngIntegral',
    listKey: 'specificActivitySystemMngIntegralList',
    alias: 'SPECIFIC_ACTIVITY_SYSTEM_MNG_INTEGRAL'
  },
  {
    type: 'SPECIFIC_ACTIVITY_VERTEBRA_HELP_INTERNAL',
    stateKey: 'specificActivityVertebraHelpInternal',
    listKey: 'specificActivityVertebraHelpInternalList',
    alias: 'SPECIFIC_ACTIVITY_VERTEBRA_HELP_INTERNAL'
  },
  {
    type: 'SPECIFIC_ACTIVITY_ALIGN_STRATEGY',
    stateKey: 'specificActivityAlignStrategy',
    listKey: 'specificActivityAlignStrategyList',
    alias: 'SPECIFIC_ACTIVITY_ALIGN_STRATEGY'
  },
  {
    type: 'SPECIFIC_ACTIVITY_COORDINATION_AREAS',
    stateKey: 'specificActivityCoordinationAreas',
    listKey: 'specificActivityCoordinationAreasList',
    alias: 'SPECIFIC_ACTIVITY_COORDINATION_AREAS'
  },
  {
    type: 'SPECIFIC_ACTIVITY_DIRECTION_TEAM',
    stateKey: 'specificActivityDirectionTeam',
    listKey: 'specificActivityDirectionTeamList',
    alias: 'SPECIFIC_ACTIVITY_DIRECTION_TEAM'
  },
  {
    type: 'SPECIFIC_ACTIVITY_STRATEGY_COMPANY',
    stateKey: 'specificActivityStrategyCompany',
    listKey: 'specificActivityStrategyCompanyList',
    alias: 'SPECIFIC_ACTIVITY_STRATEGY_COMPANY'
  },
  {
    type: 'SPECIFIC_ACTIVITY_REPORTS_ECOEFICIENCIA',
    stateKey: 'specificActivityReportsEcoeficiencia',
    listKey: 'specificActivityReportsEcoeficienciaList',
    alias: 'SPECIFIC_ACTIVITY_REPORTS_ECOEFICIENCIA'
  },
  {
    type: 'SPECIFIC_ACTIVITY_REPORTS_INTERNAL',
    stateKey: 'specificActivityReportsInternal',
    listKey: 'specificActivityReportsInternalList',
    alias: 'SPECIFIC_ACTIVITY_REPORTS_INTERNAL'
  },
  {
    type: 'SPECIFIC_ACTIVITY_REPORTS_MARKET_TARRIFS',
    stateKey: 'specificActivityReportsMarketTarrifs',
    listKey: 'specificActivityReportsMarketTarrifsList',
    alias: 'SPECIFIC_ACTIVITY_REPORTS_MARKET_TARRIFS'
  },
  {
    type: 'SPECIFIC_ACTIVITY_REPORTS_PAYMENTS',
    stateKey: 'specificActivityReportsPayments',
    listKey: 'specificActivityReportsPaymentsList',
    alias: 'SPECIFIC_ACTIVITY_REPORTS_PAYMENTS'
  },
  {
    type: 'SPECIFIC_ACTIVITY_REPORTS_SOLUTIONS_TECH',
    stateKey: 'specificActivityReportsSolutionsTech',
    listKey: 'specificActivityReportsSolutionsTechList',
    alias: 'SPECIFIC_ACTIVITY_REPORTS_SOLUTIONS_TECH'
  },
  {
    type: 'SPECIFIC_ACTIVITY_ABSENT_WORK',
    stateKey: 'specificActivityAbsentWork',
    listKey: 'specificActivityAbsentWorkList',
    alias: 'SPECIFIC_ACTIVITY_ABSENT_WORK'
  },
  {
    type: 'SPECIFIC_ACTIVITY_CULTURAL_VERTEBRA',
    stateKey: 'specificActivityCulturalVertebra',
    listKey: 'specificActivityCulturalVertebraList',
    alias: 'SPECIFIC_ACTIVITY_CULTURAL_VERTEBRA'
  },
  {
    type: 'SPECIFIC_ACTIVITY_DISENGAGEMENT',
    stateKey: 'specificActivityDisengagement',
    listKey: 'specificActivityDisengagementList',
    alias: 'SPECIFIC_ACTIVITY_DISENGAGEMENT'
  },
  {
    type: 'SPECIFIC_ACTIVITY_INDUCTION_REINDUCTION',
    stateKey: 'specificActivityInductionReinduction',
    listKey: 'specificActivityInductionReinductionList',
    alias: 'SPECIFIC_ACTIVITY_INDUCTION_REINDUCTION'
  },
  {
    type: 'SPECIFIC_ACTIVITY_SELECTION',
    stateKey: 'specificActivitySelection',
    listKey: 'specificActivitySelectionList',
    alias: 'SPECIFIC_ACTIVITY_SELECTION'
  },
  {
    type: 'SPECIFIC_ACTIVITY_SYSTEM_MNG',
    stateKey: 'specificActivitySystemMng',
    listKey: 'specificActivitySystemMngList',
    alias: 'SPECIFIC_ACTIVITY_SYSTEM_MNG'
  },
// ── Dominios para tareas pendientes (worklog_pending) ──
  {
    type: 'ACTIVITY_TYPE_TASK',
    stateKey: 'activityTypePending',
    listKey: 'activityTypePendingList',
    alias: 'ACTIVITY_TYPE_TASK'
  },
  {
    type: 'MEDIUM_REQUEST_TASK',
    stateKey: 'requestSourcePending',
    listKey: 'requestSourcePendingList',
    alias: 'MEDIUM_REQUEST_TASK'
  },
  {
    type: 'STATUS_TASK',
    stateKey: 'statusPending',
    listKey: 'statusPendingList',
    alias: 'STATUS_TASK'
  }
]
